module.exports = __webpack_public_path__ + "static/media/travel-travel1@2x.6e4432eb.png";